import { useMutation } from '@apollo/client'
import { useState } from 'react'
import toast from 'react-hot-toast'

import Button, { ButtonIntents } from 'shared/ui/Button'
import Flex from 'shared/ui/Flex'
import Input from 'shared/ui/Input'
import IslandModal from 'shared/components/modals/IslandModal'
import { REMOVE_PAGES_META } from 'data/layoutcreator/mutations/admin'

type RemovePagesMetaModalProps = {
  isOpen: boolean
  closeModal: () => void
}

const RemovePagesMetaModal: React.FC<RemovePagesMetaModalProps> = ({
  isOpen,
  closeModal,
}) => {
  const [projectId, setProjectId] = useState('')
  const [pageIdsInput, setPageIdsInput] = useState('')

  const [removePagesMeta] = useMutation(REMOVE_PAGES_META)

  const handleSubmit = async () => {
    const pageIds = pageIdsInput.split(',').map(id => id.trim()).filter(Boolean)
    
    if (pageIds.length === 0) {
      toast.error('Please enter at least one page ID')
      return
    }

    const toastId = toast.loading('Removing pages meta...')

    const { data, errors } = await removePagesMeta({
      variables: {
        projectId,
        pageIds
      }
    })

    toast.dismiss(toastId)

    if (errors) {
      toast.error('Failed to remove pages meta 😬')
      return
    } else if (data) {
      toast.success('Pages meta removed successfully 👌')
      closeModal()
    }
  }

  return (
    <IslandModal
      isOpen={isOpen}
      closeModal={closeModal}
      width={600}
      title="Remove pages meta"
    >
      <Flex direction="column">
        <Flex direction="column" rowGap={16}>
          <Input value={projectId} onChange={setProjectId} label="Project ID" />
          <Input 
            value={pageIdsInput} 
            onChange={setPageIdsInput} 
            label="Page IDs (comma-separated)" 
            placeholder="e.g. page1, page2, page3"
          />
        </Flex>

        <Flex marginTop={46}>
          <Button
            intent={ButtonIntents.dark}
            labelId="Admin.buttons.submit"
            borderRadius={100}
            isFullWidth
            isDisabled={!projectId || !pageIdsInput.trim()}
            onClick={handleSubmit}
          />
        </Flex>
      </Flex>
    </IslandModal>
  )
}

export default RemovePagesMetaModal 